import { writable } from 'svelte/store';

/**
 * For users with `isAdmin === true`, this controls whether they're acting as
 * an editor (admin) or browsing as a regular subscriber (user). Default is
 * 'user' — admin powers (edit FABs, preview-only progress tracking) only
 * kick in when they explicitly choose «Авторизуватися як адмін» on the
 * AdminEntry chooser.
 *
 * Persisted to localStorage so reloads keep the chosen role.
 */
export type AdminMode = 'user' | 'admin';

const STORAGE_KEY = 'fou:adminMode';

function readInitial(): AdminMode {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'admin' ? 'admin' : 'user';
  } catch {
    return 'user';
  }
}

export const adminMode = writable<AdminMode>(readInitial());

adminMode.subscribe((m) => {
  try {
    localStorage.setItem(STORAGE_KEY, m);
  } catch {
    /* private mode / quota — silently ignore */
  }
});
